/**
 * Get environment variable value
 * Priority: window.env (runtime) > process.env (build-time)
 * 
 * @param {string} key - The environment variable key
 * @param {string} defaultValue - Default value if not found
 * @returns {string} The environment variable value
 */
export function getEnv(key, defaultValue = '') {
  // First, try to get from runtime config (window.env)
  if (window.env && window.env[key] && window.env[key] !== `__${key}__`) {
    return window.env[key];
  }
  
  // Fallback to build-time environment variable
  if (process.env[key]) {
    return process.env[key];
  }
  
  return defaultValue;
}

// Export commonly used environment variables
export const VUE_APP_API_URL = getEnv('VUE_APP_API_URL', '/api');
export const VUE_APP_GTM_ID = getEnv('VUE_APP_GTM_ID', '');
